/**
 * Global configuration utility to fetch and manage the API base URL.
 * It reads from /config.xml in the public folder.
 */

const normalizeApiBaseUrl = (url) => {
    if (!url) return url;
    let normalized = url.trim().replace(/\/$/, '');
    if (!normalized.endsWith('/api')) normalized += '/api';
    return normalized;
};

let apiBaseUrl = normalizeApiBaseUrl('https://localhost:5000'); // Default fallback
if (typeof window !== 'undefined') {
    apiBaseUrl = '/api';
}

export const loadConfig = async () => {
    try {
        const response = await fetch('/config.xml');
        const text = await response.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, "text/xml");
        const node = xmlDoc.getElementsByTagName("server_url")[0];
        const url = node && node.childNodes && node.childNodes[0] ? node.childNodes[0].nodeValue : '';
        if (url) {
            apiBaseUrl = normalizeApiBaseUrl(url);
            console.log("API Base URL loaded from config.xml:", apiBaseUrl);
        }
    } catch (error) {
        console.error("Error loading config.xml, using default:", error);
    }
    return apiBaseUrl;
};

export const getApiUrl = () => apiBaseUrl;

export const formatDate = (value) => {
    if (!value) return "-";
    if (typeof value === "string") {
        const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) {
            const y = Number(m[1]);
            const mo = Number(m[2]);
            const d = Number(m[3]);
            if (Number.isFinite(y) && Number.isFinite(mo) && Number.isFinite(d)) {
                const dd = String(d).padStart(2, "0");
                const mm = String(mo).padStart(2, "0");
                const yy = String(y % 100).padStart(2, "0");
                return `${dd}/${mm}/${yy}`;
            }
        }
    }
    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return "-";
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yy = String(dt.getFullYear() % 100).padStart(2, "0");
    return `${dd}/${mm}/${yy}`;
};

export const parseDateToIso = (value) => {
    const raw = String(value || "").trim();
    if (!raw) return "";
    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) return raw;

    const m = raw.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2}|\d{4})$/);
    if (!m) return "";
    const d = Number(m[1]);
    const mo = Number(m[2]);
    let y = Number(m[3]);
    if (!Number.isFinite(d) || !Number.isFinite(mo) || !Number.isFinite(y)) return "";
    if (y < 100) y = 2000 + y;
    if (d < 1 || d > 31) return "";
    if (mo < 1 || mo > 12) return "";
    if (y < 1900 || y > 2100) return "";
    const dd = String(d).padStart(2, "0");
    const mm = String(mo).padStart(2, "0");
    return `${y}-${mm}-${dd}`;
};

export const getTodayIso = () => {
    const dt = new Date();
    const yyyy = String(dt.getFullYear());
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};
